import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { HttpParams } from '@angular/common/http';
import { ProvidersService } from '../providers.service';
import { Params, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { MatTabGroup } from '@angular/material/tabs';
import { formatDate } from '@angular/common';
import { AdminViewService } from 'src/app/framework/services/admin-view.service';

@Component({
  selector: 'app-billing-report',
  templateUrl: './all-providers.component.html',
  styleUrls: ['./all-providers.component.scss']
})
export class AllProvidersComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {

  columnDefs
  rowData: any = [];
  rowSelection;
  private gridApi;
  private gridColumnApi;
  searchValue;
  showEditProvider: boolean = false;
  showDeleteProvider: boolean = false;
  selectedRows: any;
  isButtonDisabled:boolean
  constructor(private router: Router, private providersService: ProvidersService, private adminViewServices:AdminViewService) {
    super();
    this.providersService.getallproviders().subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        resData.forEach(element => {
          element.createdDtm = formatDate(element.createdDtm, 'yyyy-MM-dd', 'en');
        });
       
        this.setGrid(resData);
      }
    })
  }

  setGrid(data: any) {
    this.rowData = data;
    this.rowSelection = 'single';
    this.columnDefs = [
      { field: 'providerId', headerName: 'providerId', width: 0, hide: true, sort: "desc" },
      { field: 'null', headerName: 'Action', width: 130, checkboxSelection: true },
      { field: 'providerName', headerName: 'Provider Name', width: 190 },
      { field: 'mobileNumber', headerName: 'Mobile Number', width: 190 },
      { field: 'status', headerName: 'Status', width: 190 },
      { field: 'email', headerName: 'Email Id', width: 190 },
      { field: 'contactName', headerName: 'Contact Name', width: 190 },
      { field: 'createdDtm', headerName: 'Created Date', width: 190 },
      { field: 'address1', headerName: 'Street', width: 190 },
      { field: 'city', headerName: 'City', width: 190 },
      { field: 'zip', headerName: 'Zip', width: 190 },
      { field: 'state', headerName: 'State', width: 190 }

    ]
  }

  ngOnInit(): void {
    super.ngOnInit()

     this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })

  }

  onSelectionChanged(e) {
   
    this.selectedRows = this.gridApi.getSelectedRows();
    if (this.selectedRows && this.selectedRows != []) {
      this.showEditProvider = true;
    }

  }



  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  exportData() {
    this.gridApi.exportDataAsCsv();//Done
  }

  editProvider() {


    let _providerId = this.selectedRows[0].providerId;
    if (_providerId && _providerId) {
      this.router.navigate([`features/providers/editprovider/${_providerId}`])
    }
  }
  deleteProvider() {

  }
  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  ngOnDestroy() {

    super.ngOnDestroy()
  }


}
